import React from "react";
import "../style/component/PublicationsTable.css";

function PublicationsTable({ publications = [], headerTexts = [] }) {
  return (
    <section className="publications-table-wrapper">
      <table className="publications-table rounded">
        <thead>
          <tr>
            {headerTexts.map((header, index) => (
              <th key={index} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {publications.length > 0 ? (
            publications.map((pub, index) => (
              <tr key={pub.id || index}>
                <td>{index + 1}</td>
                <td>{pub.title}</td>
                <td>{pub.publicationDate}</td>
                <td>{pub.publisher}</td>
                <td>{pub.documentType}</td>
                <td>
                  {pub.link ? (
                    <a href={pub.link} target="_blank" rel="noopener noreferrer">
                      {pub.linkText}
                    </a>
                  ) : (
                    pub.title
                  )}
                </td>
                <td>{pub.contributors}</td>
                <td>{pub.notes}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td>1</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}

export default PublicationsTable;
